'use client';

import {useState} from 'react';
import {isSuccessResult} from '@/components/form/utils';
import {ForgotPassword} from './ForgotPassword';
import {toast} from 'sonner';
import {forgotPassword} from "@/api/core/actions/auth/forgotPassword";

export function ForgotPasswordWrapper() {
  const [loading, setLoading] = useState(false)

  const handleForgotPassword = async ({ email }: { email: string }) => {
    setLoading(true);

    const result = await forgotPassword({ email });

    if (isSuccessResult(result)) {
      toast.success("Check your email for the reset link", {
        dismissible: true,
        closeButton: true,
        duration: 100000,
      });
    } else  {
      toast.error("Oops! Something went wrong.", {
        description: result.error.message,
        dismissible: true,
        closeButton: true,
        duration: 100000,
      });

      return { error: { message: "" } };
    }

    setLoading(false);
    return { success: true };
  }

  return (
    <>
      <ForgotPassword
        loading={loading}
        handleForgotPassword={handleForgotPassword}
      />
    </>
  )
}
